import { cvData } from '../data/cvData'

export const getExperience = () => {
  return cvData.experience || []
}

export const getContactInfo = () => {
  return {
    name: cvData.name || '',
    email: cvData.email || '',
    phone: cvData.phone || '',
    website: cvData.website || '',
    socialNetworks: cvData.socialNetworks || []
  }
}

export const getWelcomeMessage = () => {
  return cvData.welcomeMessage || ''
}
